import { apiRequest } from './api';
import { Planos, ApiResponse, PaginationParams } from '../types';

// Função auxiliar para normalizar dados do plano
const normalizePlan = (plano: any): Planos => {
  // Normalizar cidades para garantir que seja um array de números
  let cidades: number[] | undefined;
  
  if (plano.cidades !== null && plano.cidades !== undefined) {
    if (Array.isArray(plano.cidades)) {
      cidades = plano.cidades
        .map((id: any) => typeof id === 'number' ? id : parseInt(String(id), 10))
        .filter((id: number) => !isNaN(id) && id > 0);
    } else if (typeof plano.cidades === 'string') {
      try {
        const parsed = JSON.parse(plano.cidades);
        if (Array.isArray(parsed)) {
          cidades = parsed
            .map((id: any) => typeof id === 'number' ? id : parseInt(String(id), 10))
            .filter((id: number) => !isNaN(id) && id > 0);
        }
      } catch (e) {
        console.warn('Erro ao fazer parse das cidades do plano:', e);
      }
    }
  }

  return {
    ...plano,
    recursos: Array.isArray(plano.recursos) ? plano.recursos : [],
    cidades: cidades,
  };
};

// Função auxiliar para normalizar array de planos
const normalizePlanos = (plans: any[]): Planos[] => 
  plans.map(normalizePlan);

export const planosService = {
  // Listar todos os planos
  getAll: async (params?: PaginationParams & { ativo?: boolean; grupo_id?: number }): Promise<ApiResponse<Planos[]>> => {
    const response = await apiRequest.get<Planos[]>('/planos', { params });
    if (response.data) {
      response.data = normalizePlanos(response.data);
    }
    return response;
  },

  // Obter plano por ID
  getById: async (id: number): Promise<Planos> => {
    const response = await apiRequest.get<Planos>(`/planos/${id}`);
    return normalizePlan(response.data!);
  },

  // Criar novo plano
  create: async (plan: Partial<Planos>): Promise<Planos> => {
    const response = await apiRequest.post<Planos>('/planos', plan);
    return normalizePlan(response.data!);
  },

  // Atualizar plano
  update: async (id: number, plan: Partial<Planos>): Promise<Planos> => {
    const response = await apiRequest.put<Planos>(`/planos/${id}`, plan);
    return normalizePlan(response.data!);
  },

  // Excluir plano
  delete: async (id: number): Promise<void> => {
    await apiRequest.delete(`/planos/${id}`);
  },

  // Buscar planos ativos
  getActive: async (): Promise<Planos[]> => {
    const response = await apiRequest.get<Planos[]>('/planos/active');
    return response.data ? normalizePlanos(response.data) : [];
  },

  // Buscar planos para select (rota otimizada)
  getForSelect: async (params?: { 
    ativo?: 'true' | 'false' | 'todos', 
    limit?: number, 
    search?: string, 
    escritorio_id?: number 
  }): Promise<ApiResponse<Planos[]>> => {
    const response = await apiRequest.get<Planos[]>('/planos/select', { params });
    if (response.data) {
      response.data = normalizePlanos(response.data);
    }
    return response;
  },

  getServicosByPlano: async (
    planoId: number,
    filtro: 'ativos' | 'cancelados' = 'ativos'
  ): Promise<ApiResponse<PlanoServicoVinculado[]>> => {
    return apiRequest.get<PlanoServicoVinculado[]>(`/planos/${planoId}/servicos`, {
      params: { filtro },
    });
  },
};

export interface PlanoServicoVinculado {
  id: number;
  contrato_id: number;
  tipo: string;
  status: string;
  usuario_pppoe?: string;
  endereco_inst?: string;
  cidade_inst?: string;
  data_cancelamento?: string;
  data_instalacao?: string;
  contrato?: {
    id: number;
    titulo: string;
    status: string;
    cliente_id: number;
    cliente?: {
      id: number;
      nome: string;
    };
  };
}